import timg1 from '../images/team/1.jpg'
import timg2 from '../images/team/2.jpg'
import timg3 from '../images/team/3.jpg'
import timg4 from '../images/team/4.jpg'


const Teams = [
    {
        Id: '1',
        tImg:timg1,
        slug:'Harry-Abraham',
        name:'Harry Abraham',
        title:'Founder',
    },
    {
        Id: '2',
        tImg:timg2,
        slug:'Robert-Johnson',
        name:'Robert Johnson',
        title:'Admin',
    },
    {
        Id: '3',
        tImg:timg3,
        slug:'Jenelia-Orkid',
        name:'Jenelia Orkid',
        title:'Merketer',
    },
    {
        Id: '4',
        tImg:timg4,
        slug:'Aliza-Anny',
        name:'Aliza Anny',
        title:'Merketer',
    }
]

export default Teams;